{
  "welcome_back": "Välkommen tillbaka",
  "golfer": "Golfspelare",
  "your_rounds": "Senaste rundorna",
  "no_rounds_yet": "Inga rundor ännu",
  "start_first_round_message": "Starta din första runda för att spåra dina golfresultat!",
  "start_your_first_round": "Starta din första runda",
  "latest_registrations": {
    "title": "Senaste registreringar",
    "show_more": "Visa mer"
  },
  "tabs": {
    "my_rounds": "Mina rundor",
    "all": "Alla",
    "upcoming": "Kommande"
  },
  "welcome": "Välkommen,",
  "welcome_first": "Välkommen att använda Impactia!",
  "empty_subtitle": "Du har inga rundor ännu. Börja spåra och se hur ditt spel utvecklas.",
  "start_round": "Starta runda",
  "browse_calendar": "Bläddra i tävlingskalender",
  "hcp": "HCP",
  "sections": {
    "ongoing": "Pågående",
    "upcoming": "Kommande",
    "past": "Avslutade"
  },
  "manager": {
    "weather": {
      "loading": "Hämtar väderdata…",
      "forecast_loading": "Laddar prognos…",
      "forecast_unavailable": "Prognos ej tillgänglig",
      "error": "Fel",
      "refresh": "Uppdatera väder",
      "updated": "Uppdaterad",
      "feels_like": "Känns som",
      "wind": "Vind m/s",
      "humidity": "Luftfuktighet %",
      "pressure": "Tryck hPa",
      "uv_index": "UV-index",
      "rain_probability": "Regnsannolikhet %",
      "station_suffix": "FMI",
      "time_prefix": "kl",
      "days": {
        "su": "Sön",
        "ma": "Mån",
        "ti": "Tis",
        "ke": "Ons",
        "to": "Tor",
        "pe": "Fre",
        "la": "Lör"
      },
      "days_short": {
        "su": "SÖ",
        "ma": "MÅ",
        "ti": "TI",
        "ke": "ON",
        "to": "TO",
        "pe": "FR",
        "la": "LÖ"
      },
      "compass": {
        "n": "N",
        "ne": "NO",
        "e": "Ö",
        "se": "SO",
        "s": "S",
        "sw": "SV",
        "w": "V",
        "nw": "NV"
      },
      "conditions": {
        "clear": "Klart",
        "mostly_clear": "Mestadels klart",
        "cloudy": "Molnigt",
        "foggy": "Dimmigt",
        "drizzle": "Duggregn",
        "rain": "Regn",
        "snow": "Snö",
        "rain_showers": "Regnskurar",
        "snow_showers": "Snöbyar",
        "thunderstorm": "Åska"
      }
    },
    "upcoming_competitions": {
      "title": "Tävlingar",
      "show_more": "Visa fler",
      "no_upcoming": "Inga kommande tävlingar",
      "prev": "Tidigare tävlingar",
      "next": "Kommande tävlingar"
    },
    "members": {
      "title": "Sällskapets medlemmar",
      "invite": "Lägg till medlemmar",
      "inviteModal": {
        "title": "Bjud in medlemmar",
        "tabs": {
          "email": "E-post",
          "link": "Inträdesl änk & QR",
          "ebirdie": "eBirdie"
        },
        "joinCode": {
          "description": "Dela inträdesländken eller QR-koden så kan spelare gå med i sällskapet själva.",
          "regenerate": "Skapa ny kod",
          "codeLabel": "Inträdesk od",
          "linkLabel": "Inträdesl änk",
          "copyLink": "Kopiera länk",
          "copied": "Kopierad",
          "qrHint": "Spelaren kan gå med genom att skanna QR-koden eller öppna länken.",
          "shareQr": "Dela QR-kod",
          "shareTitle": "Sällskapets inträdesk od",
          "error": "Hantering av inträdesk oden misslyckades."
        },
        "ebirdieNoEmail": "Ingen e-postadress hittades för den här spelaren, så hen kan inte bjudas in.",
        "emailsLabel": "E-postadresser",
        "emailPlaceholder": "medlem@example.com",
        "addAddress": "Lägg till adress",
        "removeEmail": "Ta bort adress",
        "help": "Vi skickar en inbjudan per e-post till var och en. En adress som inte har ett konto ännu får en registreringslänk — medlemskapet aktiveras när inbjudan accepteras i appen.",
        "send": "Skicka inbjudningar",
        "resultSummary": "Inbjudningar skickade: {{invited}} nya, {{already}} redan på listan, {{invalid}} ogiltiga",
        "errorGeneric": "Det gick inte att skicka inbjudningarna."
      },
      "columns": {
        "name": "Namn",
        "email": "E-post",
        "status": "Status",
        "invited": "Inbjuden",
        "joined": "Gått med"
      },
      "status": {
        "invited": "Inbjuden – inget konto",
        "awaiting": "Väntar på godkännande",
        "active": "Medlem"
      },
      "empty": "Inga medlemmar",
      "actions": "Åtgärder",
      "select": "Välj",
      "selectAll": "Välj alla",
      "delete": "Ta bort medlemmar",
      "deleteConfirm": {
        "header": "Ta bort medlemmar",
        "body": "Vill du ta bort {{count}} medlemmar från gemenskapen? Detta kan inte ångras.",
        "confirm": "Ta bort"
      },
      "deleteSuccess": "{{count}} medlemmar har tagits bort",
      "deleteError": "Det gick inte att ta bort medlemmarna"
    }
  },
  "societyInvite": {
    "label": "Inbjudan till sällskap",
    "body": "har bjudit in dig som medlem. Som medlem kan du se sällskapets evenemang och anmäla dig till dem.",
    "decline": "Avvisa",
    "accept": "Acceptera"
  },
  "latest_scorecards": {
    "title": "Senaste resultatkort",
    "empty": "Inga sparade resultatkort",
    "has_statistics": "Innehåller statistik",
    "types": {
      "competition": "Tävlingsrunda",
      "handicap": "Handikappgrundande runda",
      "regular": "Träningsrunda"
    }
  },
  "latest_payments": {
    "title": "Senaste betalningar",
    "show_more": "Visa mer",
    "empty": "Inga betalningar"
  }
}
